import { SxProps, Theme } from '@mui/material';


export const COMMENTS_STYLES = {
  container: {
    width: "100%",
    maxWidth: 1280,
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "center",
    px: { xs: 2, md: 4 },
    boxSizing: "border-box",
  } as SxProps<Theme>,

  stack: {
    alignItems: "center",
    width: "100%",
  } as SxProps<Theme>,

  card: {
    width: { xs: "100%", md: 509 },
    height: { xs: "auto", md: 300 },
    minHeight: { xs: 250, md: 300 },
    borderRadius: "10px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "5px",
      borderTopLeftRadius: "10px",
      borderTopRightRadius: "10px",
      background: "linear-gradient(90deg, rgba(111,215,253,1) 0%, rgba(196,244,216,1) 100%)",
      zIndex: 1,
      pointerEvents: "none",
    },
  } as SxProps<Theme>,

  cardContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    minHeight: "100%",
    p: { xs: 2, md: 3 },
    "&:last-child": {
      pb: { xs: 2, md: 3 },
    },
  } as SxProps<Theme>,

  contentBox: {
    width: "100%",
    maxWidth: { xs: "100%", md: 422 },
    height: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  } as SxProps<Theme>,

  contentText: {
    fontSize: { xs: "16px", md: "18px" },
    fontWeight: 400,
    color: "black",
    textAlign: "center",
    whiteSpace: "pre-line",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 8,
    WebkitBoxOrient: "vertical",
    flex: 1,
    marginBottom: 2.5,
  } as SxProps<Theme>,

  authorText: {
    fontSize: { xs: "16px", md: "18px" },
    fontWeight: 400,
    color: "black",
    textAlign: "center",
  } as SxProps<Theme>,
};
